export default {
  Anz_Krippe: {
    d: 'm -1,1 2,0 0,-2 -2,0 z',
    fill: '#be0021',
    label: 'Kinderkrippen',
    order: 0,
  },
  Anz_KiGa: {
    d: 'M -1.16,1 1.16,1 0,-1 Z',
    fill: '#a9c571',
    label: 'Kindergärten',
    order: 1,
  },
  Anz_alterserw_KiGa: {
    d: 'M -1,0 A 1,1 0 1 0 1,0 1,1 0 1 0 -1,0',
    fill: '#009bd2',
    label: 'alterserweiterte KiGa',
    order: 2,
  },
  VS_Ki_NMB_vorh: {
    d:
      'm 0.5,-1 0,0.5 0.5,0 0,1 -0.5,0 0,0.5 -1,0 0,-0.5 -0.5,0 0,-1 0.5,0 0,-0.5 z',
    fill: '#ff9900',
    label: 'Horte & schulische Betreuung',
    order: 3,
  },
}



// WEBPACK FOOTER //
// ./src/data/symbols.js